import { render } from "./ResultsMultiple.vue?vue&type=template&id=90130246&scoped=true&lang=pug"
import script from "./ResultsMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsMultiple.vue?vue&type=script&setup=true&lang=js"

import "./ResultsMultiple.vue?vue&type=style&index=0&id=90130246&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90130246"]])

export default __exports__